import React from 'react';
import * as JsPDF from 'jspdf'
import {RobotoRegular, PdfBack} from './pdf';
import {getPackageName} from "../../../Shared/common";

function exportCouponToPdf({code, packageCode, packageName, packageExpiry, creation}) {
    const msg = 'Καλέστε με αστική χρέωση στο 2111084461';
    const msg1 = '(Δευτέρα έως Παρασκευή 07:30 - 16:00) για να κλείσετε ραντεβού!';
    const doc = new JsPDF();
    doc.addFileToVFS("Roboto-Regular.ttf", RobotoRegular);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    doc.setFontSize(14);

  
   if(packageCode === "003") 
   {   
       // addImage(base64, type, x, y, w, h)
       doc.addImage(PdfBack, 'PNG', 0, 0, 210, 297);
       doc.setFont('Helvetica');
       doc.text(81, 104, code || ''); // 34
       doc.setFont('Roboto'); // set font
       doc.text(packageCode === '001' ? 75 : 53, 139, packageName || '');
       doc.setFont('Helvetica');
       doc.text(93, 174, packageExpiry || '');
       doc.text(93, 207, creation || '');
       doc.setFont('Roboto');
       doc.text(65, 250, msg || '' );
       doc.text(39.5, 255, msg1 || '');
       doc.save(`${code}.pdf`);
   }

   else if ((packageCode === "004") || (packageCode === "011")) // yde or new yde
    {
        // addImage(base64, type, x, y, w, h)
        doc.addImage(PdfBack, 'PNG', 0, 0, 210, 297);
        doc.setFont('Helvetica');
        doc.text(81, 104, code || ''); // 34
        doc.setFont('Roboto'); // set font
        doc.text(packageCode === '001' ? 75 : 65.5, 139, packageName || '');
        doc.setFont('Helvetica');
        doc.text(93, 174, packageExpiry || '');
        doc.text(93, 207, creation || '');
        doc.setFont('Roboto');
        doc.text(65, 250, msg || '' );
        doc.text(39.5, 255, msg1 || '');
        doc.save(`${code}.pdf`);
    }
   
   else 
   {
       // addImage(base64, type, x, y, w, h)
       doc.addImage(PdfBack, 'PNG', 0, 0, 210, 297);
       doc.setFont('Helvetica');
       doc.text(81, 104, code || ''); // 34
       doc.setFont('Roboto'); // set font
       doc.text(packageCode === '001' ? 75 : 53, 139, packageName || '');
       doc.setFont('Helvetica');
       doc.text(93, 174, packageExpiry || '');
       doc.text(93, 207, creation || '');
       doc.save(`${code}.pdf`);
   }
}

function CouponMeta({label, text, className}) {
    return (
        <div>
            <h6>{label}</h6>
            <p className={className}>{text}</p>
        </div>
    )
}

function CouponAction({code, packageCode, packageName, packageExpiry, creation}) {
    const action = (e) => {
        e.preventDefault();
        exportCouponToPdf({code, packageCode, packageName, packageExpiry, creation})
    };
    return (
        <a onClick={action} href="#" className={"print-button"}>
            <span className="print-icon"/>
        </a>
    )
}

function Coupon({coupon, idx}) {
    const {code, packageCode, packageExpiry, creation} = coupon;
    const packageName = getPackageName(packageCode);
    const couponProps = {code, packageCode, packageName, packageExpiry, creation};
    return (
        <div className={"coupon-container"}>
            <div className={"coupon"}>
                <CouponMeta label={"Κωδικός υπηρεσίας"} text={code}/>
                <CouponMeta label={"Υπηρεσία"} className={"title"} text={packageName}/>
                <CouponMeta label={"Λήξη"} text={packageExpiry}/>
                <CouponMeta label={"Έκδοση"} text={creation}/>
                <CouponAction {...couponProps}/>
            </div>
        </div>
    );
}

function Coupons({coupons}) {
    return (
        <div>
            <div className={"coupons-container"}>
                {coupons.map((coupon, key) => {
                    const couponProps = {coupon, idx: key, key};
                    return <Coupon {...couponProps} />;
                })}
            </div>
        </div>
    );
}

export default Coupons;
